import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['box', 'title', 'text'];

  show(event) {
    const wrapper = event.currentTarget.closest("[data-controller~='tooltip']") || this.element;
    const title = wrapper.dataset.tooltipTitle || '';
    const text = wrapper.dataset.tooltipText || '';

    this.titleTarget.textContent = title;
    this.textTarget.textContent = text;

    this.titleTarget.classList.toggle('hidden', !title);
    this.textTarget.classList.toggle('hidden', !text);

    this.boxTarget.classList.remove('hidden');
    this.move(event);
  }

  move(event) {
    if (this.boxTarget.classList.contains('hidden')) return;

    const offsetX = 14;
    const offsetY = 14;
    const padding = 12;

    let left = event.clientX + offsetX;
    let top = event.clientY + offsetY;

    this.boxTarget.style.left = '0px';
    this.boxTarget.style.top = '0px';
    this.boxTarget.style.visibility = 'hidden';
    this.boxTarget.classList.remove('hidden');

    const rect = this.boxTarget.getBoundingClientRect();

    if (left + rect.width + padding > window.innerWidth) {
      left = event.clientX - rect.width - offsetX;
    }

    if (top + rect.height + padding > window.innerHeight) {
      top = event.clientY - rect.height - offsetY;
    }

    left = Math.max(padding, left);
    top = Math.max(padding, top);

    this.boxTarget.style.left = `${left}px`;
    this.boxTarget.style.top = `${top}px`;
    this.boxTarget.style.visibility = 'visible';
  }

  hide() {
    this.boxTarget.classList.add('hidden');
  }
}
